import { type FC } from "react";
import { Loader2Icon, CheckCircle2Icon, LayersIcon } from "lucide-react";
import { Card } from "../ui/card";
import { cn } from "@/lib/utils";

// Custom tool component for get_semantic_layer_context tool
const SemanticLayerContextToolCallComponent: FC<{
  toolName: string;
  argsText: string;
  result?: unknown;
  status?: { type: "running" | "complete" | "incomplete"; reason?: string };
  args?: any;
  toolCallId?: string;
  [key: string]: any;
}> = ({ result, status }) => {
  const isRunning = status?.type === "running" || (status === undefined && result === undefined);
  const isError = status?.type === "incomplete" && status?.reason === "error";
  const isComplete = status?.type === "complete" && !isError;

  // Parse result to get counts
  let entityCount = 0;
  let relationshipCount = 0;
  let dimensionCount = 0;
  let metricCount = 0;

  if (result !== undefined && isComplete) {
    try {
      const parsed = typeof result === 'string' ? JSON.parse(result) : result;
      entityCount = (parsed?.entities || []).length;
      relationshipCount = (parsed?.relationships || []).length;
      dimensionCount = (parsed?.dimensions || []).length;
      metricCount = (parsed?.metrics || []).length;
    } catch (e) {
      // Parsing failed
    }
  }

  return (
    <Card>
      <div className={cn(
        "p-3",
        isRunning ? "bg-primary/10" : "bg-muted/50"
      )}>
        <div className="flex items-center gap-2">
          {isRunning ? (
            <>
              <Loader2Icon className="h-4 w-4 text-primary animate-spin flex-shrink-0" />
              <span className="text-sm">Loading current semantic layer...</span>
            </>
          ) : isComplete ? (
            <>
              <CheckCircle2Icon className="h-4 w-4 text-success flex-shrink-0" />
              <span className="text-sm">
                Found {entityCount} entities, {relationshipCount} relationships, {dimensionCount} dimensions, {metricCount} metrics
              </span>
            </>
          ) : (
            <>
              <LayersIcon className="h-4 w-4 text-muted-foreground flex-shrink-0" />
              <span className="text-sm text-muted-foreground">Checking semantic layer context...</span>
            </>
          )}
        </div>
      </div>
    </Card>
  );
};

export const SemanticLayerContextToolCall = SemanticLayerContextToolCallComponent as React.ComponentType<any>;
